export class StringWrapper {
  value?: string;

  constructor(value?: string) {
    this.value = value
  }
}
